module.exports = __webpack_public_path__ + "static/media/attraction4.b899a92c.jpg";